import GlobalInfobar from './GlobalInfobar';

interface WithGlobalInfobarLayoutProps {
  children: React.ReactNode;
}

/**
 * Wraps children with the global infobar region. Content is loaded from `REACT_APP_PERSONALIZATION_URL` (same-origin
 * path such as `/static/json/customer-hub-personalisation.json`, or an absolute URL when hosted elsewhere).
 * @returns {React.ReactNode} The wrapped component with the global infobar region.
 */
const WithGlobalInfobarLayout: React.FC<WithGlobalInfobarLayoutProps> = ({ children }) => {
  return (
    <div id="global-layout">
      <div id="global_infobar">
        <GlobalInfobar />
      </div>
      {children}
    </div>
  );
};

export default function withGlobalInfobar<P>(WrappedComponent: React.ComponentType<P>) {
  return (props: P) => (
    <WithGlobalInfobarLayout>
      <WrappedComponent {...props} />
    </WithGlobalInfobarLayout>
  );
}
